import { createResponseId } from "./event-types.js";
import { beaconLog } from "./testing.js";
function instrumentProductLink(context, link, product, position, responseId) {
    link.addEventListener("mousedown", () => {
        void context.events.reportProductClick({
            position,
            responseId,
            ...product,
        });
    });
}
async function processSimpleSearchPage(context, callbacks) {
    beaconLog("Instrumenting search page...");
    const responseId = createResponseId();
    const cards = await callbacks.listProductCards();
    let position = 1;
    const products = [];
    const numberOfResults = await callbacks.getNumberOfResults();
    for (const card of cards) {
        const product = await callbacks.getProductDataFromCard(card);
        products.push(product);
        const links = await callbacks.listProductLinksInCard(card);
        for (const link of links) {
            instrumentProductLink(context, link, product, position, responseId);
        }
        const purchaseLinks = await callbacks.listPurchaseLinksInCard(card);
        for (const purchaseLink of purchaseLinks) {
            const currentPosition = position;
            purchaseLink.addEventListener("mousedown", async () => {
                await context.events.reportAddToCart({
                    ...product,
                    quantity: 1,
                });
                await context.events.reportProductClick({
                    position: currentPosition,
                    responseId,
                    ...product,
                });
            });
        }
        ++position;
    }
    await context.events.reportSearch({
        query: await callbacks.getQuery(),
        products,
        numberOfResults,
        responseId,
    });
}
async function processSimpleProductListingPage(context, callbacks) {
    beaconLog("Instrumenting product listing page...");
    const responseId = createResponseId();
    const categories = await callbacks.getCategories();
    const cards = await callbacks.listProductCards();
    const numberOfResults = await callbacks.getNumberOfResults();
    let position = 1;
    const products = [];
    for (const card of cards) {
        const product = await callbacks.getProductDataFromCard(card);
        products.push(product);
        const links = await callbacks.listProductLinksInCard(card);
        for (const link of links) {
            instrumentProductLink(context, link, product, position, responseId);
        }
        const purchaseLinks = await callbacks.listPurchaseLinksInCard(card);
        for (const purchaseLink of purchaseLinks) {
            const currentPosition = position;
            purchaseLink.addEventListener("mousedown", async () => {
                await context.events.reportAddToCart({
                    ...product,
                    quantity: 1,
                });
                await context.events.reportProductClick({
                    position: currentPosition,
                    responseId,
                    ...product,
                });
            });
        }
        ++position;
    }
    await context.events.reportProductListing({
        category: categories.join(";"),
        products,
        numberOfResults,
        responseId,
    });
}
async function processSimpleProductViewPage(context, callbacks) {
    beaconLog("Instrumenting product view page...");
    const product = await callbacks.getProductData();
    async function reportProductViews(currentProduct) {
        await context.events.reportProductView({
            ...currentProduct,
        });
        const additionalProducts = await callbacks.getAdditionalProductViewData?.();
        for (const additionalProduct of additionalProducts ?? []) {
            await context.events.reportProductView({
                ...additionalProduct,
            });
        }
    }
    await reportProductViews(product);
    callbacks.listenForProductVariantChanges?.(() => {
        void callbacks.getProductData().then(reportProductViews);
    });
    const links = await callbacks.listAddToCartLinks();
    for (const link of links) {
        link.addEventListener("mousedown", async () => {
            const quantity = await callbacks.getAddToCartQuantity();
            await context.events.reportAddToCart({
                ...product,
                quantity,
            });
            const additionalProducts = await callbacks.getAdditionalProductViewData?.();
            for (const additionalProduct of additionalProducts ?? []) {
                await context.events.reportAddToCart({
                    ...additionalProduct,
                    quantity,
                });
            }
        });
    }
}
async function processSimpleCheckoutPage(context, callbacks) {
    beaconLog("Instrumenting checkout page...");
    const links = await callbacks.listPurchaseLinks();
    for (const link of links) {
        link.addEventListener("mousedown", async () => {
            const products = await callbacks.listProducts();
            await context.events.reportPurchase({
                products,
            });
            const additionalProducts = await callbacks.listAdditionalPurchaseProducts?.();
            if (additionalProducts != null && additionalProducts.length > 0) {
                await context.events.reportPurchase({
                    products: additionalProducts,
                });
            }
        });
    }
}
export async function processPage(context, options) {
    if (options.searchPage != null && options.searchPage.isOnSearchPage(context)) {
        await processSimpleSearchPage(context, options.searchPage);
    }
    else if (options.productListingPage != null && options.productListingPage.isOnProductListingPage(context)) {
        await processSimpleProductListingPage(context, options.productListingPage);
    }
    else if (options.productViewPage != null && options.productViewPage.isOnProductViewPage(context)) {
        await processSimpleProductViewPage(context, options.productViewPage);
    }
    else if (options.purchasePage != null && options.purchasePage.isOnPurchasePage(context)) {
        await processSimpleCheckoutPage(context, options.purchasePage);
    }
    else if (options.fallback != null) {
        await options.fallback(context);
    }
}
//# sourceMappingURL=simple-callbacks.js.map